import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import useHomeContext from 'Context/HomeContext';
import ContactWithManyEmails from './ContactWithManyEmails';
import ContactWithOnlyLoginEmail from './ContactWithOnlyLoginEmail';

const ContactPicker = (props) => {
  const { homeResource } = useHomeContext();
  const Component = pick(homeResource, {
    [fr.relationships.onlyLoginEmailAddress.name]: ContactWithOnlyLoginEmail,
  }, ContactWithManyEmails);

  return <Component {...props} />;
};


export default ContactPicker;
